// extracted by mini-css-extract-plugin
export default {"statics":"Statics_statics__+3zrh","active":"Statics_active__Dvl7Z"};